export default "__VITE_ASSET__CYN557lJ__"